import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gap-2 flex items-center md:items-end"
}
const _hoisted_2 = {
  key: 0,
  class: "text-white text-xl3-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "text-white text-base-bold mb-1"
}

import { formatCurrency } from '@/utils/text-transforms';
import { computed } from 'vue';
import loadingData from '@/assets/animated-icons/Loading_dots_white.json';
import { QuotePremiumDetails } from '@/interfaces/entities/premium-details.interface';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import { useFormStore } from '@/store';
import { InsuranceQuoteSummary } from '@/interfaces';
import { PaymentFrequency } from '@/enums/payment-frequency';

// Props
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'PremiumDetailsReviewStickyFooter',
  props: {
    fields: {},
    policyInRenewal: { type: Boolean },
    buttonText: {},
    isLoading: { type: Boolean },
    premiumDetails: {},
    insuranceQuoteSummary: {},
    paymentFrequency: {},
    disableSubmit: { type: Boolean }
  },
  emits: ['buttonClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const loadingIconData = loadingData as any;

const formStore = useFormStore();

// Self service premium details text
// ------------------------------------------------------------- //

const stickyFooterText = computed(() => {
  let stickyFootText = '';
  const quotePremiumDetails = props.premiumDetails;
  if (quotePremiumDetails?.premiumChanged) {
    if (quotePremiumDetails?.annualRefund) {
      stickyFootText = formatCurrency(quotePremiumDetails?.annualRefund, 2);
    } else {
      stickyFootText = props.premiumDetails?.monthlyNonResponsiveDeposit
        ? formatCurrency(props.premiumDetails?.monthlyNonResponsiveDeposit ?? 0, 2)
        : props.premiumDetails?.annualNonResponsivePremium
          ? props.policyInRenewal
            ? formatCurrency(props.premiumDetails?.annualNonResponsivePremium ?? 0, 2)
            : formatCurrency(props.premiumDetails?.annualNonResponsiveAmountDue ?? 0, 2)
          : formatCurrency(props.premiumDetails?.annualResponsiveAmountDue ?? 0, 2);
    }
  }
  return stickyFootText;
});

const stickySmallText = computed(() => {
  let stickyFootText = '';
  const quotePremiumDetails = props.premiumDetails;
  if (quotePremiumDetails?.premiumChanged) {
    if (quotePremiumDetails?.annualRefund) {
      stickyFootText = props.fields.refundText.value;
    } else {
      stickyFootText = quotePremiumDetails?.monthlyNonResponsiveDeposit
        ? props.policyInRenewal
          ? props.fields.renewalFirstMonthlyPaymentLabel.value
          : props.fields.nextMonthlyPaymentsLabel?.value
        : props.policyInRenewal
          ? props.fields.yearLabelNoSymbol.value
          : props.fields.annualLabel.value;
    }
  } else {
    stickyFootText = props.fields.noChangesToPremium.value;
  }
  return stickyFootText;
});

// Quote texts
// ------------------------------------------------------------- //

const stickyFooterQuoteText = computed(() => {
  let stickyFootText = '';
  const insuranceQuoteSummary = props.insuranceQuoteSummary;
  if (insuranceQuoteSummary) {
    stickyFootText =
      props.paymentFrequency === PaymentFrequency.Monthly
        ? formatCurrency(props.insuranceQuoteSummary?.monthlyDeposit ?? 0, 2)
        : formatCurrency(props.insuranceQuoteSummary?.yearlyAnnualPremium ?? 0, 2);
  }
  return stickyFootText;
});
const stickySmallQuoteText = computed(() => {
  let stickyFootText = '';
  const insuranceQuoteSummary = props.insuranceQuoteSummary;
  if (insuranceQuoteSummary) {
    stickyFootText =
      props.paymentFrequency === PaymentFrequency.Monthly
        ? props.fields.monthlyLabel.value
        : props.fields.yearLabel.value;
  }
  return stickyFootText;
});

const emit = __emit;

// Functions
// ------------------------------------------------------------- //

const buttonClicked = (values: any) => {
  emit('buttonClicked', values);
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (stickyFooterText.value || stickyFooterQuoteText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(Text), {
                  field: { value: _ctx.premiumDetails ? stickyFooterText.value : stickyFooterQuoteText.value }
                }, null, 8, ["field"])
              ]))
            : _createCommentVNode("", true),
          (stickySmallText.value || stickySmallQuoteText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(Text), {
                  field: { value: _ctx.premiumDetails ? stickySmallText.value : stickySmallQuoteText.value }
                }, null, 8, ["field"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_unref(DotLottieVue), {
          key: 1,
          autoplay: "",
          style: {"width":"40px","height":"40px"},
          loop: "",
          data: _unref(loadingIconData)
        }, null, 8, ["data"])),
    _createVNode(_component_FormKit, {
      type: "submit",
      label: _ctx.buttonText,
      disabled: _unref(formStore)?.disableAllSteps || _ctx.isLoading || _ctx.disableSubmit,
      inputClass: "btn btn-primary btn-md w-[126px]",
      outerClass: "ml-auto",
      onClick: buttonClicked
    }, null, 8, ["label", "disabled"])
  ], 64))
}
}

})